/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Group_One_To_OneInputs */

const en_service_type_group_one_to_one = /** @type {(inputs: Service_Type_Group_One_To_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One to one`)
};

const pl_service_type_group_one_to_one = /** @type {(inputs: Service_Type_Group_One_To_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening indywidualny`)
};

/**
* | output |
* | --- |
* | "One to one" |
*
* @param {Service_Type_Group_One_To_OneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_group_one_to_one = /** @type {((inputs?: Service_Type_Group_One_To_OneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Group_One_To_OneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_group_one_to_one(inputs)
	return en_service_type_group_one_to_one(inputs)
});